<template>
  <div style="height: 100%;">
    <page v-if="$route.path === '/plan/activity'">
      <ZuiHeader/>
      <SubPageTemplate page-title="节庆活动" :pid="$cid.play.jieQingHuoDong" :page-size="6" type="article"
                       :video-mask="false" :ext1-empty="false" @article-click="articleClick"></SubPageTemplate>
      <ZuiFooter/>
    </page>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";

export default {
  components: {
    SubPageTemplate
  },
  data() {
    return {
      pid: null,
      tabId: ''
    }
  },
  created() {
    this.tabId = this.$route.query.id;
  },
  methods: {
    articleClick(item) {
      this.$openNewWindow('/new/plan/activity/info?id=' + item.id);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/plan/activity.vue